var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 278,
    viewBox: "0 0 278 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    filter: "url(#filter0_d_201_399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M177.734 93.4811C179.139 92.1106 180.37 90.5902 181.908 89.5139C182.997 88.7537 184.525 88.6475 185.818 88.1488C187.005 87.6911 187.618 88.0344 188.28 89.1325C210.368 125.753 188.745 173.601 146.698 181.091C113.761 186.958 82.7035 165.958 75.7682 133.134C68.5851 99.1349 91.858 65.5119 126.216 60.2886C141.042 58.0353 154.894 60.8118 167.776 68.4955C168.647 69.0159 168.74 69.5118 168.661 70.5417C168.37 74.3645 165.704 76.4871 163.172 78.8439C149.963 70.7188 135.866 68.5282 120.944 73.0567C109.293 76.5933 100.155 83.6476 93.6224 93.9089C80.3808 114.718 84.1956 141.823 102.554 158.212C120.642 174.359 148.089 175.04 167.003 159.899C186.67 144.158 191.855 115.715 177.734 93.4784V93.4811Z",
    fill: "#4059C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M155.934 86.1597C153.129 88.9634 150.428 91.7045 147.656 94.3693C147.411 94.6036 146.66 94.4782 146.216 94.3175C137.146 91.007 128.451 91.7617 120.293 96.9496C110.415 103.233 105.467 115.309 107.942 126.613C110.543 138.491 119.803 147.212 131.643 148.934C153.08 152.057 169.968 131.131 162.371 110.816C161.968 109.737 162.131 109.132 162.915 108.372C165.453 105.914 167.918 103.383 170.431 100.857C178.627 114.02 178.597 135.872 162.951 150.318C147.711 164.392 124.089 164.465 108.811 150.528C93.4181 136.485 91.2425 112.941 103.871 96.4646C117.108 79.1926 139.969 76.7049 155.931 86.157L155.934 86.1597Z",
    fill: "#4059C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M188.242 68.4409H203.537C203.03 69.0049 202.731 69.37 202.398 69.7051C198.456 73.656 194.524 77.6177 190.545 81.5304C190.031 82.0372 189.282 82.3424 188.593 82.6257C187.97 82.8819 187.292 83.059 186.622 83.1271C182.663 83.5303 179.825 85.6529 177.097 88.4648C168.286 97.5517 159.259 106.434 150.284 115.363C149.522 116.121 149.323 116.775 149.565 117.832C151.3 125.428 146.29 133.117 138.665 134.662C130.883 136.24 123.346 131.21 121.9 123.477C120.438 115.644 125.538 108.14 133.329 106.936C135.248 106.639 137.288 106.914 139.245 107.148C140.114 107.252 140.634 107.156 141.247 106.543C151.333 96.4128 161.446 86.3123 171.531 76.1818C171.951 75.7595 172.152 75.1219 172.454 74.5824C172.476 74.5442 172.484 74.4979 172.495 74.4543C173.154 71.9149 173.356 69.1139 174.603 66.9069C175.831 64.7353 178.121 63.1658 179.945 61.3321C182.627 58.6374 185.312 55.9399 188.242 52.9999V68.4409Z",
    fill: "#4059C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_201_399",
    x: 0.463867,
    y: -0.0000610352,
    width: 277.072,
    height: 277.073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.252656 0 0 0 0 0.347548 0 0 0 0 0.7875 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_201_399"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_201_399",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.6cce33342896bd6fbb26c86dc6e91f72.svg";
export { ForwardRef as ReactComponent };